import type { Components } from "@mui/material/styles";
import type { Theme } from "../types";

export const MuiFormGroup = {
	styleOverrides: { root: { gap: "16px" } },
} satisfies Components<Theme>["MuiFormGroup"];
